import { useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  // CircularProgress,
} from "@mui/material"; // Import CircularProgress for loader
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Menu from "./Menu";
const MenuAccordian = (props) => {
  const [openAccordionIndex, setOpenAccordionIndex] = useState(0);

  const presetCategory = [
    {
      Id: 0,
      // name: "Quick Boosters 🚀",
      name: "Sample Presets",
      author: "N/A",
      description:
        "Clean Workspace:10,Organize pantry:15,Write weekly affirmations:15,Do a quick workout:20",
    },
    // {
    //   Id: 1,
    //   name: "Corporate Employee",
    //   author: "N/A",
    //   description:
    //     "Organize pantry:20,Write weekly affirmations:15,Clean windows:15,Do a quick workout:20",
    // },
    // {
    //   Id: 2,
    //   name: "Students",
    //   author: "N/A",
    //   description:
    //     "Organize pantry:20,Write weekly affirmations:15,Clean windows:15,Do a quick workout:20",
    // },
    // {
    //   Id: 3,
    //   name: "Kids",
    //   author: "N/A",
    //   description:
    //     "Organize pantry:20,Write weekly affirmations:15,Clean windows:15,Do a quick workout:20",
    // },
    // {
    //   Id: 4,
    //   name: "Productive Sprint",
    //   author: "N/A",
    //   description:
    //     "Clean Workspace:10,Organize pantry:15,Write weekly affirmations:15,Do a quick workout:20",
    // },
    // {
    //   Id: 5,
    //   name: "Workout",
    //   author: "N/A",
    //   description: "Comming Soon...",
    // },
  ];
  // Function to handle Accordion toggle
  const handleAccordionToggle = (index) => {
    if (index === openAccordionIndex) {
      // Clicked on the currently open Accordion, close it
      setOpenAccordionIndex(null);
      //   setIsAnswerEditable(false); // not sure but keep both line
      //   doEmpty();
    } else {
      // Clicked on a different Accordion, open it
      setOpenAccordionIndex(index);
      //   setIsAnswerEditable(false); // not sure but keep both line
      //   doEmpty();
    }
  };

  return (
    <div
      style={{
        // display: "flex",
        // justifyContent: "center",
        // alignItems: "center", // Centers vertically
        backgroundColor: "lightgray",
        width: "85vw", // Ensures it spans the full width of the viewport
        maxWidth: "450px",
        height: "70vh", // Ensures it spans the full height of the viewport
        maxHeight: "400px",
        overflow: "auto",
        borderRadius: "15px",
      }}
    >
      <div
        style={{
          //   width: "90%", // Occupies 90% of the device width
          //   height: "80%", // Occupies 80% of the device height
          padding: "10px",
          borderRadius: "5px",
          //   margin: "5px",
          backgroundColor: "white",

          boxShadow: "0 2px 10px rgba(0,0,0,0.2)", // Optional for better look
        }}
      >
        {presetCategory.map((item, index) => (
          <Accordion
            key={item.Id}
            expanded={index === openAccordionIndex}
            onChange={() => handleAccordionToggle(index)}
            style={{
              marginBottom: "10px",
              borderRadius: "10px",
              overflow: "hidden",
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <div style={{ display: "flex", alignItems: "center" }}>
                {/* <div
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    backgroundColor: "#ccc",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginRight: "10px",
                  }}
                >
                  {item.Id}
                </div> */}
                <Typography>{item.name}</Typography>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <Menu
                setTaskName={props.setTaskName}
                setIsMenuOn={props.setIsMenuOn}
                addTasksToList={props.addTasksToList}
              ></Menu>
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </div>
  );
};
export default MenuAccordian;
